export enum ActionResult {
  OK = "ok",
  BLOCKED = "blocked",
  INVALID = "invalid",
  NOT_FOUND = "notFound",
  SAME_PLATFORM = "samePlatform",
  INVALID_COMMAND = "invalidCommand",
  GAME_OVER = "gameOver",
}
export interface Character {
  id: string;
  name: string;
  size: number;
  svgUrl: string;
  svgUrlFail: string;
  svgIn: string;
  type: "adult" | "child" | "animal";
}
export interface PlatformAreas {
  A: Character[];
  B: Character[];
  Carrier: Character[];
}
